var dataesalab = [
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-10-18_large.png?v=1647580942",
    "Title": "Glycated haemoglobin (HbA1c) - Blood Glucose",
    "Price": "Rs.1,750.00",
    "id": 0
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/webimages-27_large.png?v=1641973540",
    "Title": "Urinary Analysis - Urine Detailed Report D/R",
    "Price": "Rs.450.00",
    "id": 1
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-10-19_3a79c74d-dc29-47be-b9e4-a02b9bab7a19_large.png?v=1647584931",
    "Title": "Platelet Count",
    "Price": "Rs.390.00",
    "id": 2
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/vbm_8bccd0b7-2aa7-40ea-91d7-7ad0db4d2c60_large.jpg?v=1647856143",
    "Title": "UCE Profile",
    "Price": "Rs.2,490.00",
    "id": 3
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Liver-Functions-Test---LFT-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996451_large.jpg?v=1653996452",
    "Title": "Liver Functions Test - LFT",
    "Price": "Rs.1,650.00",
    "id": 4
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Lipid-Profile-_Triglycerides_---Cholesterol-Testing-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996446_large.jpg?v=1653996447",
    "Title": "Lipid Profile (Triglycerides)",
    "Price": "Rs.2,190.00",
    "id": 5
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/ediRapid-Covid--PCR-in-15-minutes-Dr-Essa-Laboratory-and-Diagnostic-Centre-16553996394_large.jpg?v=1654254229",
    "Title": "Serum Uric Acid",
    "Price": "Rs.690.00",
    "id": 6
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-10-13_b9661361-281e-4d01-a76d-93caac16397f_large.png?v=1647584816",
    "Title": "MP (Malarial Parasite)",
    "Price": "Rs.650.00",
    "id": 7
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/opi_large.jpg?v=1647581004",
    "Title": "(CBC ESR) – Blood Test",
    "Price": "Rs.890.00",
    "id": 8
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/DisplayFileFormFileName_large.webp?v=1711795758",
    "Title": "CBC",
    "Price": "Rs.690.00",
    "id": 9
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/mvx_4d80287f-f480-4e38-8c86-1866e395bbf0_large.jpg?v=1647584442",
    "Title": "FBS (Glucose Fasting )",
    "Price": "Rs.290.00",
    "id": 10
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Random-Blood-Glucose-_RBG_-Test-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996409_large.jpg?v=1653996411",
    "Title": "Random Blood Sugar (RBS) Test",
    "Price": "Rs.290.00",
    "id": 11
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-10-08_large.png?v=1647584822",
    "Title": "MP ICT",
    "Price": "Rs.990.00",
    "id": 12
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/lk_c3c66e8c-293d-4f1c-a6ce-cc01b55966d2_large.jpg?v=1647856156",
    "Title": "Urea",
    "Price": "Rs.690.00",
    "id": 13
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Electrolytes-_Serum_-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996438_large.png?v=1653996439",
    "Title": "Electrolytes (Serum)",
    "Price": "Rs.1,270.00",
    "id": 14
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/SGPT-_ALT_-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996596_large.jpg?v=1653996598",
    "Title": "SGPT (ALT)",
    "Price": "Rs.490.00",
    "id": 15
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Sodium-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996492_large.jpg?v=1653996493",
    "Title": "Sodium",
    "Price": "Rs.460.00",
    "id": 16
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/Creatinine-Test-High-Low-Normal-Levels-1_large.jpg?v=1708938195",
    "Title": "Creatinine",
    "Price": "Rs.650.00",
    "id": 17
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Potassium-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996499_large.png?v=1653996501",
    "Title": "Potassium",
    "Price": "Rs.460.00",
    "id": 18
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/vbm_85e4db15-5857-429a-8ef0-e45337a5de53_large.jpg?v=1647847188",
    "Title": "PROTHROMBIN TIME - (PT-INR)",
    "Price": "Rs.890.00",
    "id": 19
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-10-20_951e78d0-03dd-4e5c-98e5-1c09251ac180_large.png?v=1647584700",
    "Title": "Iron",
    "Price": "Rs.850.00",
    "id": 20
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/vbm_a5189e7c-4b56-4c45-b307-920281c8a360_large.jpg?v=1647584540",
    "Title": "Hemoglobin Profile (Hb)",
    "Price": "Rs.400.00",
    "id": 21
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/e_3ec8e298-0eff-429d-8ffa-47217ff45581_large.jpg?v=1647847025",
    "Title": "Magnesium",
    "Price": "Rs.680.00",
    "id": 22
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/vitamin-d-test_large.jpg?v=1712561529",
    "Title": "25 OH Vitamin-D Total",
    "Price": "Rs.3,090.00",
    "id": 23
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-10-14_a7ffe430-ba22-4af3-b80b-a4e5ca94ef79_large.png?v=1647584473",
    "Title": "ESR (Westergren method)",
    "Price": "Rs.390.00",
    "id": 24
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Electrolytes-_Urinary_-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996459_large.jpg?v=1653996460",
    "Title": "Electrolytes (Urinary)",
    "Price": "Rs.1,270.00",
    "id": 25
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Estimated-GFR-_eGFR_-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996468_large.png?v=1653996470",
    "Title": "Estimated GFR (eGFR)",
    "Price": "Rs.1,270.00",
    "id": 26
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/20220625_085015_724938_xet-nghiem-sot-xuat-h.max-800x800_large.jpg?v=1708938323",
    "Title": "Dengue NS1 Antigen",
    "Price": "Rs.2,550.00",
    "id": 27
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-10-02_1257cd59-caca-4474-844f-2910154e791c_large.png?v=1647847082",
    "Title": "Malaria Parasitic Load",
    "Price": "Rs.750.00",
    "id": 28
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/nmk_561fdf33-5ecc-4a4b-8ebe-2928a63a9e51_large.jpg?v=1647584886",
    "Title": "Phosphorus",
    "Price": "Rs.590.00",
    "id": 29
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Low-density-lipids-_LDL_-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996572_large.jpg?v=1653996574",
    "Title": "Low density lipids (LDL)",
    "Price": "Rs.630.00",
    "id": 30
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/webimages-35_large.png?v=1641974010",
    "Title": "Stool D/R",
    "Price": "Rs.450.00",
    "id": 31
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-10-12_681436fb-5f38-441f-8767-5a88e69d2e7b_large.png?v=1647584528",
    "Title": "Hbs Ab",
    "Price": "Rs.1,590.00",
    "id": 32
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/website-covid.jpgm_large.jpg?v=1647856330",
    "Title": "Urine Pregnancy Test",
    "Price": "Rs.460.00",
    "id": 33
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Triglycerides-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996575_large.jpg?v=1653996576",
    "Title": "Triglycerides",
    "Price": "Rs.620.00",
    "id": 34
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/default-0a612a95ebe844deb29fd819711ab621_e5dbf144-8a39-4c30-8b0a-c9270b1745c3_large.jpg?v=1718264444",
    "Title": "Total Protein",
    "Price": "Rs.620.00",
    "id": 35
  },
  {
    "imgurl": "https://dressalab.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif",
    "Title": "Micro Albumin(Urine)",
    "Price": "Rs.1,090.00",
    "id": 36
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/LDH-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996617_large.jpg?v=1653996618",
    "Title": "LDH",
    "Price": "Rs.630.00",
    "id": 37
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/DELDLogoPNG_fce8a934-b935-4106-9404-bd83b22c83aa_large.png?v=1719225646",
    "Title": "Blood Group",
    "Price": "Rs.690.00",
    "id": 38
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Protein-A-G-Ratio-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996456_large.jpg?v=1653996457",
    "Title": "Protein A/G Ratio",
    "Price": "Rs.890.00",
    "id": 39
  },
  {
    "imgurl": "https://dressalab.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif",
    "Title": "Iron Studies",
    "Price": "Rs.2,490.00",
    "id": 40
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/Cholesterol-blood-test-sample_large.jpg?v=1711795186",
    "Title": "Cholesterol",
    "Price": "Rs.590.00",
    "id": 41
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/mklo_dcc8eb95-ddfe-4154-ace4-a8d6def7e44e_large.jpg?v=1647856007",
    "Title": "TIBC",
    "Price": "Rs.990.00",
    "id": 42
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/SGOT-_AST_-Dr-Essa-Laboratory-and-Diagnostic-Centre-1653996607_large.jpg?v=1653996608",
    "Title": "SGOT (AST)",
    "Price": "Rs.490.00",
    "id": 43
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/website-covid.jl_228521b3-a491-4110-8fa7-a316d54c2aca_large.jpg?v=1647584911",
    "Title": "Platelet Count For PRP",
    "Price": "Rs.450.00",
    "id": 44
  },
  {
    "imgurl": "https://dressalab.com/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_large.gif",
    "Title": "Glucose Tolerance test (GTT)",
    "Price": "Rs.1,270.00",
    "id": 45
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/default-0a612a95ebe844deb29fd819711ab621_e5dbf144-8a39-4c30-8b0a-c9270b1745c3_large.jpg?v=1718264444",
    "Title": "Cortisol (Evening)",
    "Price": "Rs.2,090.00",
    "id": 46
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/default-0a612a95ebe844deb29fd819711ab621_e5dbf144-8a39-4c30-8b0a-c9270b1745c3_large.jpg?v=1718264444",
    "Title": "Beta hCG",
    "Price": "Rs.1,990.00",
    "id": 47
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/default-0a612a95ebe844deb29fd819711ab621_e5dbf144-8a39-4c30-8b0a-c9270b1745c3_large.jpg?v=1718264444",
    "Title": "Bleeding Time - BT",
    "Price": "Rs.460.00",
    "id": 48
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/default-0a612a95ebe844deb29fd819711ab621_e5dbf144-8a39-4c30-8b0a-c9270b1745c3_large.jpg?v=1718264444",
    "Title": "Anti HCV",
    "Price": "Rs.2,250.00",
    "id": 49
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/WhatsAppImage2023-02-20at12.18.40PM_2_large.jpg?v=1676878136",
    "Title": "Women health package",
    "Price": "Rs.12,640.00",
    "id": 50
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/WhatsAppImage2023-02-20at12.18.39PM_5_large.jpg?v=1676878698",
    "Title": "Obesity Screening",
    "Price": "Rs.4,560.00",
    "id": 51
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/WhatsAppImage2023-02-20at12.18.39PM_3_large.jpg?v=1676878311",
    "Title": "Liver health screening",
    "Price": "Rs.10,400.00",
    "id": 52
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/WhatsAppImage2023-02-20at12.18.39PM_2_large.jpg?v=1676878081",
    "Title": "Smokers Screening",
    "Price": "Rs.4,900.00",
    "id": 53
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/WhatsAppImage2023-02-20at12.18.39PM_4_large.jpg?v=1676878556",
    "Title": "Osteoporasis Screening",
    "Price": "Rs.4,270.00",
    "id": 54
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/WhatsAppImage2023-02-20at12.18.40PM_1_large.jpg?v=1676878015",
    "Title": "Men health package",
    "Price": "Rs.6,848.00",
    "id": 55
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/WhatsAppImage2023-02-20at12.18.40PM_large.jpg?v=1676877889",
    "Title": "Gyne Package",
    "Price": "Rs.7,670.00",
    "id": 56
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/search-test_small.png?v=1697202711",
    "Title": "Clinical Bio Chemistry",
    "Price": "Rs.2,200.00",
    "id": 57
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/health-icon_small.png?v=1697193931",
    "Title": "Covid-19 Testing",
    "Price": "Rs.2,490.00",
    "id": 58
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/pharmacy-icon-removebg-preview_small.png?v=1697534911",
    "Title": "Pharmacy",
    "Price": "Rs.1,950.00",
    "id": 59
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/ziconia-crown_small.png?v=1697195147",
    "Title": "Dental Services",
    "Price": "Rs.3,950.00",
    "id": 60
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/health-icon_small.png?v=1697193931",
    "Title": "Health Package",
    "Price": "Rs.2,900.00",
    "id": 61
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/search-test_small.png?v=1697202711",
    "Title": "Special Test",
    "Price": "Rs.1,950.00",
    "id": 62
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/home-lab_small.png?v=1697527489",
    "Title": "Home Lab Test",
    "Price": "Rs.2,490.00",
    "id": 63
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/search-test_small.png?v=1697202711",
    "Title": "CT Scan",
    "Price": "Rs.1,500.00",
    "id": 64
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/files/Physiotherapy_Service-12_small.png?v=1696599204",
    "Title": "Home Physiotheraphy",
    "Price": "Rs.1,500.00",
    "id": 65
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled_600x600px_large.png?v=1641631966",
    "Title": "U/S Upper abdomen - (Portable)",
    "Price": "Rs.9,450.00",
    "id": 66
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-4-05_large.png?v=1641630314",
    "Title": "U/S KUB - (Portable)",
    "Price": "Rs.31,500.00",
    "id": 67
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-4-03_large.png?v=1641630161",
    "Title": "U/S FWB - (Portable)",
    "Price": "Rs.19,125.00",
    "id": 68
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-4-02_large.png?v=1641630065",
    "Title": "U/S Abdomen & Pelvis - (Portable)",
    "Price": "Rs.13,500.00",
    "id": 69
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-1_large.png?v=1647922747",
    "Title": "U/S Prostate - (Portable)",
    "Price": "Rs.2,600.00",
    "id": 70
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-4-06_large.png?v=1641631679",
    "Title": "U/S pelvis - Portable",
    "id": 71
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-4-08_large.png?v=1641631751",
    "Title": "U/S KUB - & Pelvis (Portable)",
    "id": 72
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-1-07_large.png?v=1641880705",
    "Title": "Physiotherapy Home Visit 1",
    "id": 73
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-5-03_large.png?v=1641632638",
    "Title": "Physiotherapy 1 Visit - (Home Visit)",
    "id": 74
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-8-01_large.jpg?v=1647430628",
    "Title": "Physiotherapy 7 Visits - (Home Visit)",
    "id": 75
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-1-06_large.png?v=1641880625",
    "Title": "Physiotherapy 26 Visits - (Home Visit)",
    "id": 76
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-1-03_large.png?v=1641880143",
    "Title": "Physiotherapy 15 Visits - (Home Visit)",
    "id": 77
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-8-02_large.jpg?v=1647430544",
    "Title": "Physiotherapy 10 Visits - (Home Visit)",
    "id": 78
  },
  {
    "imgurl": "https://dressalab.com/cdn/shop/products/LogoPicture_e6d07d5c-48e1-4ae7-b4a1-f7eea2c60d47_large.jpg?v=1637315934",
    "Title": "Fitness",
    "id": 79
  }
]

var testData = {
  "Ultrasound": {
    "U/S Whole Abdomen": 2200,
    "U/S Upper abdomen": 2000,
    "U/S FWB": 1500,
    "U/S Pelvis": 1500,
    "U/S Whole Abdomen + Prostate": 2250,
    "U/S KUB": 2000,
    "U/S KUB & Prostate": 2500,
    "U/S KUB & Testis": 2050,
    "KUB Prostate Lower Abdomen": 2000,
    "U/S Liver & gall bladder": 1500,
    "U/S Abdomen & Pelvis": 2250
  },
  "ECG": {
    "ECG": 1000,
    "ECG (Portable)": 2000
  },
  "X-Rays": {
    "Chest PA": 1100,
    "Sacro coccyx Spine AP/LAT": 1500,
    "Dorsal spine AP/LAT": 1500,
    "Lumbo sacral spine AP/LAT": 1500,
    "Elbow joint AP/LAT": 1000,
    "Forearm AP/LAT": 1150,
    "Hand AP/LAT": 1000,
    "Heel AP/LAT": 1000,
    "Hip joint AP/LAT": 1300,
    "Leg AP/LAT": 1300,
    "Nasal bone Lateral View": 1000,
    "Para nasal sinuses (PNS)": 1260,
    "Pelvis AP": 1300,
    "K.U.B X-RAY": 1300,
    "Radius ulna AP/LAT": 1000,
    "Shoulder AP/LAT View": 1150,
    "Wrist joint AP/LAT": 1000,
    "Wrist for bone age": 1000,
    "Knee AP/LAT": 1000,
    "Both Knee AP/LAT Standing": 1300
  }
}
const servicedData = [
  {
      "Text": "Our X-ray department has latest Digital Computerized Radiology CR Equipment. All reporting are done by qualified FCPS- Radiologist",
      "imgurl": "https://dressalab.com/cdn/shop/files/Untitled-3-11_900x900.png?v=1641286494",
      "about": "X-ray"
  },
  {
      "Text": "At AHK Portable X-Ray & Diagnostic Service, we provide comprehensive and precise ultrasound imaging services designed to meet your diagnostic needs. Our state-of-the-art equipment and highly skilled radiologists ensure high-quality imaging for accurate diagnosis and treatment planning.",
      "imgurl": "https://dressalab.com/cdn/shop/files/Untitled-3-10_900x900.png?v=1639564234",
      "about": "Ultrasound"
  },
  {
      "Text": "This test determine the response of your heart to increased workload and demand for blood. This is achieved by recording the ECG whilst you are walking on a treadmill machine",
      "imgurl": "https://dressalab.com/cdn/shop/products/Untitled-3-13_900x900.png?v=1641793769",
      "about": "Exercies Tolerance Test ETT"
  },
  {
      "Text": "For the convenience of patients, a three channel Electrocardiogram service is provided. Apart from convenience of all facilities being under one roof, the Diagnostic Centers offer a more reliable service based on the most modern and sophisticated equipment available anywhere in the Pakistan. Such equipment is backed by highly skilled manpower including consultant medical specialists",
      "imgurl": "https://dressalab.com/cdn/shop/files/Untitled-2_900x900.png?v=1641295403",
      "about": "Electrocardiogram (ECG)"
  },
  {
      "Text": "AHK Portable Xray and Diagnostic Service introduced first chain of Physiotherapy services. Our physiotherapy services are considered as best in Karachi. With Qualified DPT, we make sure to that our patients are satisfied and content with our service.",
      "imgurl": "https://dressalab.com/cdn/shop/files/Untitled-3-07_900x900.png?v=1641287500",
      "about": "Physiotherapy"
  },
]


export {dataesalab,testData,servicedData};